import { capabilitiesForRole, normalizeRole, type AppRole, type CapabilityKey } from '@/auth/permissions';

const HOME_BY_ROLE: Record<AppRole, string> = {
  ADMIN: '/dashboard',
  GERENTE_INV: '/asistencia',
  SUPERVISOR: '/dashboard',
  ALMACENISTA: '/inventario',
  CHOFER: '/rutas/mis-rutas',
  CONSULTA: '/inventario',
  CONSULTOR_SAI: '/soporte/sai',
  PROVEEDOR: '/inventario',
  OFICINA: '/asistencia',
  RH: '/admin/rh',
  VENTAS_INTERNAS: '/admin/cliente-portal',
  COBRANZA: '/admin/cliente-portal',
  GERENTE_LOGISTICA: '/rutas',
  MKT: '/asistencia',
  CLIENTE: '/cliente',
  OPERADOR: '/inventario',
  VENDEDOR: '/vendedor',
};

function getRequiredCapabilityForPath(path: string): CapabilityKey | undefined {
  if (path.startsWith('/admin/ventas/contenido')) return 'canManageSalesContent';
  if (path === '/admin' || path.startsWith('/admin?')) return 'canViewAdminRh';
  if (path.startsWith('/admin/rh')) return 'canViewAdminRh';
  if (path.startsWith('/admin/usuarios')) return 'canViewAdminUsers';
  if (path === '/admin/cliente-portal') return undefined;
  if (path.startsWith('/admin/cliente-portal/quote-intake')) return 'canManageClientQuoteIntake';
  if (path.startsWith('/admin/cliente-portal/order-requests')) return 'canManageClientQuoteIntake';
  if (path.startsWith('/admin/cliente-portal/invoice-requests')) return 'canManageClientBilling';
  if (path.startsWith('/admin/reportes/cotizaciones')) return 'canViewAdminCotizaciones';
  if (path.startsWith('/admin/reportes')) return 'canViewAdminReports';
  if (path.startsWith('/admin/movimientos')) return 'canViewAdminInventory';
  if (path.startsWith('/admin/inventario')) return 'canViewAdminInventory';
  if (path.startsWith('/admin/etiquetas')) return 'canViewAdminInventory';
  if (path.startsWith('/admin/erp')) return 'canViewAdminInventory';
  if (path.startsWith('/admin/')) return 'canViewAdminInventory';
  if (path.startsWith('/agente')) return 'canUseAgent';
  if (path.startsWith('/vendedor')) return undefined;
  if (
    path.startsWith('/operaciones') ||
    path.startsWith('/entradas') ||
    path.startsWith('/salidas') ||
    path.startsWith('/salida') ||
    path.startsWith('/transferencia') ||
    path.startsWith('/conteo')
  ) {
    return 'canUseOperations';
  }
  if (path.startsWith('/actividades')) return 'canViewActivities';
  if (path.startsWith('/tracking')) return 'canViewDashboard';
  if (path.startsWith('/rutas')) return 'canUseRoutes';
  if (path.startsWith('/inventario')) return 'canViewInventory';
  if (path.startsWith('/proveedor/agenda')) return 'canViewProviderAgenda';
  if (path.startsWith('/cliente')) return 'canViewClientPortal';
  if (path.startsWith('/admin')) return 'canViewAdminInventory';
  return undefined;
}

export function getHomePathForRole(role?: string | null): string {
  return HOME_BY_ROLE[normalizeRole(role)];
}

export function isPathAllowedForRole(role: string | null | undefined, path: string): boolean {
  const normalized = normalizeRole(role);
  const capability = getRequiredCapabilityForPath(path);
  if (!capability) return true;
  const capabilities = capabilitiesForRole(normalized);
  return capabilities[capability];
}

export function ensureAllowedPath(role: string | null | undefined, path: string): string {
  const normalized = normalizeRole(role);
  const capability = getRequiredCapabilityForPath(path);
  if (capability && !capabilitiesForRole(normalized)[capability]) {
    return getHomePathForRole(normalized);
  }
  return path;
}
